(function () {
    'use strict';

    angular
        .module('garnaCabinet')
        .factory('User', User);

    User.$inject = ['$resource'];

    /* @ngInject */
    function User($resource) {
        return $resource('api/profile/:userId',
            {userId: '@id'},
            {
               // 'save': {method: 'POST', isArray: true},
               // 'get': { method:'GET', cache: true},
                'update': {method:'PUT', isArray:true}
            });
    }

})();

